export const PREMIUM_LOAD = '@@complex/PREMIUM_LOAD';



// WEBPACK FOOTER //
// ./src/app/Complex/actionTypes.js